import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../../Common';
import ValidatedSelect from '../../common/forms/ValidatedSelect';
import { FormContext } from '../../common/forms/FormElements';

export const DispatchOffice = () => {
    const { setFieldValue } = useContext(FormContext);
    const { data, isLoading } = useQuery({ queryKey: ['dispatchOffices'], queryFn: () => httpClient.js(ApiRoutes.typeAheads.selectableDispatchLocations()) });

    return (
        <ValidatedSelect
            id="dispatchOfficeLocationId"
            name="dispatchOfficeLocationId"
            options={data}
            isLoading={isLoading}
            label="Which office is dispatching this job?"
            required
            error="You must select a dispatch office for this job"
            onChange={() => setFieldValue('dispatchPortId', '')}
        />
    );
};